import { defineComponent } from "vue";
import { useRoute } from "vue-router";
import { useViewStore } from "src/stores/view";
import standardOption from "./standardOption.vue";
/**
 * Standard way to display options. With both router style and normal
 */
export default defineComponent({
    components: {
        standardOption,
    },
    props: {
        additionalData: {
            type: Object,
        },
        badgeCount: {
            type: Number,
            default: 0,
        },
        icon: {
            type: String,
            required: true,
        },
        iconRight: Boolean,
        iconSize: {
            type: String,
            default: "1.1rem",
        },
        routerData: {
            type: Object,
        },
        showSeparator: Boolean,
        title: {
            type: String,
            required: true,
        },
    },
    emits: ["click"],
    setup() {
        const vueRoute = useRoute();
        const viewStore = useViewStore();
        /**
         * Go to route and close drawer
         */
        function goRoute(routeData) {
            if (routeData.name !== vueRoute.name)
                return;
            viewStore.toggleDrawer(false);
        }
        return { goRoute };
    },
});
